<template>
    <div class="language-wrapper">
        <div class="modal-header d-flex align-items-center">
            <h3>{{ $TL.selectLanguage }}</h3>
            <div class="current-lang d-flex align-items-center">
                <p>{{ $TL.currentLanguage }}：</p>
                <button class="v-btn language-btn">
                    <i
                        class="flag"
                        :style="`background-image: url(${currentLang.flag});`"
                    >
                    </i>
                    <span class="country">{{ currentLang.name }}</span>
                </button>
            </div>
        </div>
        <div class="modal-body scrollbar">
            <ul class="continent-list">
                <li class="item" v-for="(item, k) in langs" :key="k">
                    <h4 class="continent-name">{{ k }}</h4>
                    <div class="country-list d-flex flex-wrap">
                        <div class="cat" v-for="(lan, j) in item" :key="j">
                            <v-btn
                                class="lang-btn"
                                :lang="lan.name"
                                :code="lan.code"
                                @click="
                                    change_language(
                                        lan.code,
                                        lan.name,
                                        lan.thumbnail
                                    )
                                "
                            >
                                <i :style="get_flags(lan.thumbnail)"></i>
                                <span>{{ lan.name }}</span>
                            </v-btn>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
    name: "language-wrapper",
    props: {
        langs: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapState("global", ["currentLang", "isNewBeveliver"]),
    },
    components: {},
    created() {},
    mounted() {},
    methods: {
        ...mapMutations("global", ["updateAccessLang"]),
        ...mapMutations("triggerEvtents", [
            "updateGetMenusData",
            "updateGetSchemaData",
            "updateInitSearchCondition",
            "updateClearSearchCondition",
            "updateResetSideNav",
        ]),

        ...mapMutations("search", ["updateSearchCondition"]),
        get_flags(image) {
            return `background-image: url(${image});`;
        },
        //  切换语言
        change_language(lang, name, flag) {
            //  如果用户在收藏页或收藏详情页
            this.$P.returnIndex(this);
            //  清除搜索条件
            this.updateClearSearchCondition();
            //  初始化筛选条件
            this.updateInitSearchCondition();
            //  重置侧边栏
            this.updateResetSideNav();

            this.updateAccessLang({ lang, name, flag });
            this.$P.schemaType = "basicData";
            this.updateGetSchemaData();
            this.updateGetMenusData();

            this.$emit("closeModel");

            this.$P.$emit("glTranslateChangeLang", lang);
        },
    },
};
</script>

<style lang="scss">
.v-dialog.language-dialog {
    width: 742px;
    outline: none;
}

.language-wrapper {
    .modal-header,
    .modal-body {
        padding: 8px 20px;
    }

    .modal-header {
        height: 62px;
        background-color: #efefef;
        border-bottom: 1px solid #dfe1e5;

        h3 {
            font-size: 22px;
            line-height: 1.2;
        }
    }

    .modal-body {
        overflow-y: auto;
        height: 60vh;
    }

    .language-btn {
        margin-left: 4px;
        span {
            color: $color-font;
        }
    }

    .current-lang {
        height: 100%;
        margin-left: 30px;

        p {
            font-size: 16px;
            font-weight: 700;
            margin: 0;
        }
    }

    .continent-list {
        .cat {
            width: 20%;
            padding-right: 20px;
        }

        li.item {
            width: 100%;
            margin-bottom: 16px;
        }

        .continent-name {
            width: 100%;
            padding: 14px 0;
            border-bottom: 1px solid #dfe1e5;
            font-size: 16px;
        }

        .country-list {
            margin-top: 18px;

            .lang-btn {
                width: 100%;
                padding: 5px 10px 5px 5px;
                border: 1px solid transparent;
                border-radius: 38px;
                transition: all 0.3s ease;
                text-align: left;
                justify-content: flex-start;
                margin: {
                    bottom: 8px;
                }

                &:hover,
                &.active {
                    border-color: rgba(#0063c4, 0.4);
                    background-color: #d6e2f5;
                }

                i {
                    display: inline-block;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    flex-shrink: 0;

                    background: {
                        repeat: no-repeat;
                        size: cover;
                        position: center center;
                    }
                }

                .v-btn__content span {
                    font-size: 12px;
                    padding-left: 8px;
                    line-height: 1.2em;
                    white-space: normal;
                }
            }
        }
    }
}
</style>
